module.exports = __webpack_public_path__ + "img/icon-media-unlocked.bac6eaac.svg";